module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/additional-briefing-elite-reward-100.2015f70a.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/additional-briefing-elite-reward-100.png
// module id = 3766
// module chunks = 11